// Player Goals — per-player scorer odds table (Phase 3 → M2 wave 9). Thin wrapper
// over <PlayerMarketTable>; reads the player-goals dataset + bookmaker + scope +
// market type (Anytime / First / 2+). Market type comes from mod.dataset.marketType
// (the legacy source of truth), surfaced via the bridge context.
//
// The player-goals dataset now comes from app-api via `useWidgetData` (was the
// `getPlayerGoalsMarketData` legacyData getter); the controls reshape the fetched
// payload client-side (no refetch).

import { shapePlayerTable } from "@bento/shared";
import { useWidgetData } from "../../data/useWidgetData.js";
import { useFixtureKey } from "../../data/useFixtureKey.js";
import PlayerMarketTable from "./PlayerMarketTable.js";
import WidgetSkeleton from "./WidgetSkeleton.js";
import WidgetError from "./WidgetError.js";

export interface PlayerGoalsProps {
  fixture: string;
  bookmaker?: string | null;
  scope?: string | null;
  /** Market type: "Anytime" | "First" | "2+"; defaults to "Anytime". */
  marketType?: string | null;
}

export default function PlayerGoals({
  fixture,
  bookmaker,
  scope,
  marketType,
}: PlayerGoalsProps) {
  const { data, isPending, isError, refetch } = useWidgetData(
    "player-goals",
    useFixtureKey(fixture)
  );
  if (isPending) return <WidgetSkeleton />;
  if (isError) return <WidgetError onRetry={refetch} />;

  const rows =
    shapePlayerTable(
      data ?? {},
      fixture || "Arsenal v Everton",
      scope || "Match",
      bookmaker || "Pinnacle",
      marketType || "Anytime"
    ) ?? [];
  return <PlayerMarketTable wrapperClass="pg-wrapper" rows={rows} />;
}
